import React, { FunctionComponent, ReactElement, RefObject } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import TeaserInfo from '../../TeaserInfo'
import { TeaserProps, TeaserTypes } from '../TeaserInterface'
import LinkProps from '../../Link/LinkProps'
import BasicText from '../../Theme/Fonts/BasicText'
import BigListTeaserImage from './Image'

export type BigListTeaserProps = TeaserProps &
    LinkProps & {
        /** Type determines the existance of label, duration and icon on the image
         * ARTICLE type contains none but just image
         */
        type: TeaserTypes
        /**
         * property for ref forwarding
         * @TJS-type React.RefObject<Element>
         * */
        innerRef?: RefObject<Element>
    }

const BigListTeaser: FunctionComponent<BigListTeaserProps> = ({
    tag,
    headlineText,
    onShare,
    published,
    labels,
    mainImageUrl,
    mainImageAlt,
    videoDuration,
    backgroundColor = 'pearl',
    textColor = 'onyx',
    href,
    onPress,
    innerRef,
    testID,
    webRel,
    type,
}): ReactElement => {
    return (
        <Grid ref={innerRef} noExpand horizontal backgroundColor={backgroundColor}>
            <Grid flexGrow={2.1} marginRight={[4, 4, 5, 6]}>
                <Touchable onPress={onPress} href={href} testID={testID} webRel={webRel}>
                    <BigListTeaserImage
                        videoDuration={videoDuration}
                        labels={labels}
                        mainImageUrl={mainImageUrl}
                        mainImageAlt={mainImageAlt}
                        type={type}
                    />
                </Touchable>
            </Grid>
            <Grid flexGrow={2.9} minWidth={0}>
                <Grid>
                    <Touchable onPress={onPress} href={href} webRel={webRel}>
                        <BasicText
                            fontSize={['FS16', 'FS16', 'FS18', 'FS22']}
                            lineHeight={['LH20', 'LH20', 'LH22', 'LH24']}
                            numberOfLines={3}
                            color={textColor}
                            bold
                        >
                            {headlineText}
                        </BasicText>
                    </Touchable>
                </Grid>

                <TeaserInfo
                    published={published}
                    name={tag?.name}
                    imageUrl={tag?.imageUrl}
                    alt={tag?.imageAlt}
                    onShare={onShare}
                    tintColor={tag?.imageTintColor}
                />
            </Grid>
        </Grid>
    )
}

export default BigListTeaser
